/*
 * at-form-engagement.js — fires `trade_in_form_engaged` exactly once, on the
 * first real interaction with a trade-in form (a character typed, or a photo /
 * file added). Shared across all three C2B forms so the funnel step
 * "started the form" is one consistent GA4 event instead of an OR of several.
 *
 * Loaded with `defer` so window.ATFormEngagement exists before each form's
 * DOMContentLoaded init runs. Call ATFormEngagement.track(rootEl, formType) once.
 *
 * Event: trade_in_form_engaged { form_type, trigger }
 *   trigger = 'typed'       first keystroke in any text field
 *           | 'photo'       first file chosen in a file input
 *           | 'interacted'  first change on a select/checkbox/radio (e.g. condition)
 */
(function () {
  'use strict';
  if (typeof window !== 'undefined' && window.ATFormEngagement) return;

  function track(root, formType) {
    if (!root || root._atEngageTracked) return;
    root._atEngageTracked = true;
    var fired = false;

    function fire(trigger) {
      if (fired) return;
      fired = true;
      root.removeEventListener('input', onEvent, true);
      root.removeEventListener('change', onEvent, true);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'trade_in_form_engaged', { form_type: formType, trigger: trigger });
      }
    }

    // Capture phase so we still see the event even if a handler stops propagation.
    // Programmatic value changes don't emit 'input'/'change', so prefilled fields
    // (e.g. customer.email) never count as engagement.
    function onEvent(e) {
      var t = e.target;
      if (!t) return;
      if (t.type === 'file') {
        if (t.files && t.files.length) fire('photo');
        return;
      }
      if (e.type === 'input') { fire('typed'); return; }
      if (e.type === 'change') { fire('interacted'); return; }
    }

    root.addEventListener('input', onEvent, true);
    root.addEventListener('change', onEvent, true);
  }

  window.ATFormEngagement = { track: track };
})();
